// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3lm-n","title":"AfterFrontImage_title__12kQc"};